import { PdsWidget } from './pds-widget';
import {Message, PdsMessageLocation, PdsMessageType} from './models/message';
import { OrderedMap } from './models/ordered-map';
import { serviceInstances } from './services/service-instances';
import { MessageService } from './services/message-service';

export class PdsMessagesWidget extends PdsWidget {
  is = 'pds-messages-widget';
  dataMessageLocation: PdsMessageLocation;
  dataChannel: string;
  dataCanDismiss: 'true' | 'false';
  messages: Array<Message>;

  properties = {
    dataMessageLocation: {
      type: String,
      value: 'INLINE',
      observer: 'updateMessages'
    },
    dataChannel: {
      type: String,
      value: 'default'
    },
    dataCanDismiss: {
      type: String,
      value: 'true'
    },
    messages: {
      value: null
    }
  };

  getMessageLocationClass(messageLocation: PdsMessageLocation): string {
    switch (messageLocation.toUpperCase()) {
      default : //shut up typescript
      case 'INLINE':
        return 'pds-messages-inline';
      case 'DOCKED':
        return 'pds-messages-docked';
      case 'FLOATING':
        return 'pds-messages-floating';
    }
  }

  getMessageColorClass(messageValue: Message): string {
    if (messageValue.isTypeSuccess) {
      return 'pds-message-success';
    }
    if (messageValue.isTypeInfo) {
      return 'pds-message-info';
    }
    if (messageValue.isTypeWarning) {
      return 'pds-message-warning';
    }
    if (messageValue.isTypeError) {
      return 'pds-message-error';
    }
    return '';
  }

  updateMessages(): void {
    let messageService: MessageService = serviceInstances.getMessageService();
    messageService.messageChangeStream.subscribe((message: Message) => {
      this.copyMessagesFromService();
    });
    this.copyMessagesFromService();
  }

  copyMessagesFromService(): void {
    let messageService: MessageService = serviceInstances.getMessageService();
    switch (this.dataMessageLocation.toUpperCase()) {
      case 'FLOATING':
        this.messages = messageService.notificationMessages.values();
        break;
      case 'DOCKED':
        this.messages = messageService.dockedMessages.values();
        break;
      default: //shut up typescript
      case 'INLINE':
        this.messages = messageService.inlineMessages.values();
        break;

    }
  }

  executeEmbeddedHtmlMessage(event: Event): void {
    let target: any = event.target;
    target.linkItem.callback(target.linkItem);
  }

  dismiss(event: Event): void {
    let message: Message = this.extractProperty(event, 'button', 'message'); //extractProperty after merge from develop
    let messageService: MessageService = serviceInstances.getMessageService();
    messageService.removeMessage(message.location, message.message);
  }

  hasMessages(): boolean {
    return this.messages != null && this.messages.length > 0;
  }
}
